import React, { memo, useEffect } from 'react';
import CongratsComponent from "../../shared/components/congratComponent/main";


// Path to your audio file
// const audioFilePath = '/sounds/congratulation-tone.mp3';

// const bgCongratstone = `${process.env.PUBLIC_URL}/sounds/small-applause.mp3`;
const bgCongratstone = `${process.env.PUBLIC_URL}/sounds/partypopper.mp3`;

const CongratulatoryComponent = ({ isVisible }) => {

  useEffect(() => {
    if (isVisible) {
      const audio = new Audio(bgCongratstone);
      audio.play().catch(error => {
        console.error('Error playing audio:', error);
      });
    }
  }, [isVisible]);

  return (
    <CongratsComponent showCongrats={isVisible} />
  );
};

export default memo(CongratulatoryComponent);
